import React from 'react';
import PageMeta from 'src/components/organisms/page-meta';
import { SignUpComponent } from 'src/features/white-labels/techcontemporary/app/components/sign-up-component';
import { Welcome } from 'src/features/white-labels/techcontemporary/app/components/welcome';
import { Banner } from '../app/components/banner';
import { LandingCardsSection } from '../app/components/landing-cards-section';
import { LandingPageLayout } from './s7-landing.styles';

const TechContemporaryLanding = () => (
    <LandingPageLayout>
        <PageMeta title="Homepage" />
        <Banner />
        <Welcome />
        <LandingCardsSection />
        <SignUpComponent />
    </LandingPageLayout>
);

export default TechContemporaryLanding;